<!--
  PLACEHOLDER WORDING (FLOW-297, UI-DA-60-A-06 / D-22): every client-facing word
  about withdrawing this consent is awaiting the Product Owner's wording — that it
  is the business's, who may withdraw it and how (including by email). Do not
  patch it piecemeal, and do not remove the promise that it can be withdrawn.
-->
@if (isActive()) {
  <p class="ai-consent-withdraw" data-testid="ai-consent-active">
    <span>You can withdraw consent at any time.</span>
    <button
      mat-button
      type="button"
      class="ai-consent-withdraw__action"
      (click)="open()"
      data-testid="ai-consent-withdraw-btn"
    >
      Withdraw consent
    </button>
  </p>
} @else if (isWithdrawn()) {
  <p class="ai-consent-withdraw ai-consent-withdraw--done" data-testid="ai-consent-withdrawn">
    <app-icon name="shield" [size]="16" />
    <span>
      Consent for the business withdrawn on {{ state()!.revoked_at | date: 'medium' }}
      {{ routeLabel() }}. Tick the box above to consent again.
    </span>
  </p>
}
